import styled from "@emotion/styled";
import { useUIStore } from "@store/ui.store";
import { usePageNavbar } from "@shared/components/usePageNavbar";
import {
  SIDEBAR_WIDTH_COLLAPSED_PX,
  SIDEBAR_WIDTH_EXPANDED_PX,
} from "@shared/layouts/sidebar-dimensions";
import { RadarPageMoreActions } from "./RadarPageMoreActions";

const LayoutContainer = styled.div<{ $isSidebarOpenDesktop?: boolean }>`
  height: 100%;
  max-height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    margin-left: 0;
  }
`;

export const RadarLayout = ({ children }: { children?: React.ReactNode }) => {
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );
  const header = usePageNavbar({
    title: "Signals",
    rightElement: <RadarPageMoreActions />,
  });

  return (
    <LayoutContainer $isSidebarOpenDesktop={isSidebarOpenDesktop}>
      {header}
      {children}
    </LayoutContainer>
  );
};
